// src/components/store/StoreGalleryStrip.tsx
"use client";

import GallerySectionRenderer from "./sections/gallery";

export default function StoreGalleryStrip(props: any) {
  return <GallerySectionRenderer {...props} />;
}
export * from "./sections/gallery";
